<template>
    <div class="overlay-container">
        <div class="donation-info-container">
      <div v-if="!isLoaded" class="loading">Loading...</div>
      <div v-else class="donation-info">
        <img src="images/flower-1.png" class="flower flower-1">
        <div class="donation-bar">
          <div class="progress" :style="{ width: progressPercentage + '%' }"></div>
          <div class="donation-text font-extrabold text-xl text-outline-white">{{ displayText }}</div> <!-- This div displays the donation text. -->
        </div>
        <img src="images/flower-2.png" class="flower flower-2">
      </div>
    </div>

    <!-- Second donation info -->
    <div class="donation-info-container">
      <div v-if="!isLoaded" class="loading"></div>
      <div v-else class="donation-info">
        <div class="donation-bar">
          <div class="progress" :style="{ width: progressPercentage + '%' }"></div>
          <div class="donation-text font-extrabold text-xl text-outline-white">{{ displayText }}</div> <!-- This div displays the donation text. -->
        </div>
      </div>
    </div>
    </div>
  </template>  
  
  <script>
  export default {
    data() {
      return {
        isLoaded: false,
        campaignInfo: null,
      };
    },
    computed: {
      progressPercentage() {
        return (this.campaignInfo.amountRaised / this.campaignInfo.goal) * 100;
      },
      displayText() {
        return `$${this.campaignInfo.amountRaised} raised of $${this.campaignInfo.goal} goal`;
      },
    },
    methods: {
        async fetchCampaignInfo() {
            try {
            // Fetch data from the server
            const response = await fetch(`${process.env.VUE_APP_NODE_SERVER_BASE_URL}/tiltify`);
            
            // Check if the response is okay
            if (response.ok) {
                const campaignInfo = await response.json();
                this.campaignInfo = campaignInfo;
                this.isLoaded = true; // Set isLoaded to true once data is fetched
            } else {
                console.error(`Failed to fetch data: ${response.status} - ${response.statusText}`);
                // Handle error if necessary
            }
            } catch (error) {
            console.error(`Error fetching data: ${error.message}`);
            // Handle error if necessary
            }
        },
        startDataRefresh() {
            this.fetchCampaignInfo();

            // Set interval to call fetchCampaignInfo every minute (60,000 milliseconds)
            setInterval(() => {
                console.log("Fetching fresh campaign info");
                this.fetchCampaignInfo();
            }, 60000*5);
        },
    },
    async mounted() {
        this.startDataRefresh();

        setTimeout(() => {
            this.isLoaded = true;
        }, 2000);
    },
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Chakra+Petch&family=Chicle&family=Teko:wght@600&display=swap');

  .overlay-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
  }

  .donation-info-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0; /* Adjust spacing between donation info divs */
}
  
  .donation-info {
    width: 50%; /* This sets the width for the donation bar container */
    height: auto; /* Adjust height based on content */
    display: flex;
    flex-direction: column;
    justify-content: center; /* Center children vertically */
    align-items: center; /* Center children horizontally */
    position: relative;
    padding-top: 50px; /* Adjust based on flower size */
    padding-bottom: 50px; /* Adjust based on flower size */
  }
  
  .donation-bar {
  background-color: #6a996b;
  width: 100%;
  height: 50px;
  border-radius: 10px;
  border: 6px solid #6a996b;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.progress {
  background-color: #e4a228;
  height: 100%;
  transition: width 0.4s ease;
  position: absolute;
  left: 0;
  top: 0;
}

.donation-text {
  z-index: 2;
  color: #4989aa; /* Adjust color for visibility if necessary */
  position: relative;
  font-family: "Chicle", serif;
}
  
  .flower {
    position: absolute;
    height: auto; /* Adjust based on your needs */
  }
  
  .flower-1 {
    left: 0; /* Aligns with the left end of the donation bar */
    transform: translateX(-65%); /* Overlaps by 30% */
    top: calc(50% - 138/2); /* Adjust this value based on the actual height of your flowers */
    z-index: 10;
  }
  
  .flower-2 {
    right: 0; /* Aligns with the right end of the donation bar */
    transform: translateX(80%); /* Overlaps by 30% */
    top: calc(50% - 127/2); /* Adjust this value based on the actual height of your flowers */
    z-index: 10;
  }
  </style>
  